module.exports = __webpack_public_path__ + "img/banner-nucleic-test-en.0dde48ac.png";